<div class="modal-header">
  <h4 class="modal-title">{{ 'chat.sidebar.newConversation' | translate }}</h4>
  <button type="button" class="btn-close" [attr.aria-label]="'chat.dialog.cancel' | translate" (click)="close()"></button>
</div>

<div class="modal-body">
  <p class="text-muted mb-2">{{ 'chat.dialog.peopleHint' | translate }}</p>

  <!-- 2+ people = the selection became a GROUP: offer the optional label.
       Left empty, the group is displayed by its member roster. -->
  @if (selectedCount >= 2) {
    <div class="mb-2">
      <div class="input-group">
        <span class="input-group-text">
          <i class="ri-group-line" aria-hidden="true"></i>
        </span>
        <input
          type="text"
          class="form-control"
          name="chatGroupName"
          maxlength="80"
          [placeholder]="'chat.dialog.groupName' | translate"
          [attr.aria-label]="'chat.dialog.groupName' | translate"
          [(ngModel)]="groupName"
        >
      </div>
    </div>
  }

  <div class="mb-2">
    <input
      type="text"
      class="form-control"
      name="chatPeopleFilter"
      [placeholder]="'chat.dialog.searchPeople' | translate"
      [attr.aria-label]="'chat.dialog.searchPeople' | translate"
      [(ngModel)]="filterTerm"
      (input)="applyFilter()"
    >
  </div>

  <!-- Company directory lookup (T-24 · RF-01) — merged into the list below -->
  @if (loadingDirectory) {
    <div class="d-flex align-items-center gap-2 text-muted pb-2">
      <span class="spinner-border spinner-border-sm" role="status"></span>
      <small>{{ 'chat.dialog.searchingDirectory' | translate }}</small>
    </div>
  }

  @if (filteredPeople.length === 0) {
    <div class="text-center text-muted py-4">
      {{ 'chat.dialog.noPeople' | translate }}
    </div>
  } @else {
    <div class="list-group list-group-flush chat-people-list overflow-auto">
      @for (person of filteredPeople; track trackPerson($index, person)) {
        <button
          type="button"
          class="list-group-item list-group-item-action d-flex align-items-center gap-2 py-2"
          [class.active]="isSelected(person)"
          (click)="toggle(person)"
        >
          <!-- Same avatar tile as the bubble popup's list — photo/initials plus
               the presence dot, so who is around is visible before you start. -->
          <span class="chat-avatar-tile flex-shrink-0">
            @if (person.image) {
              <img [src]="person.image" [alt]="person.name">
            } @else {
              {{ person.initial }}
            }
            <span
              class="chat-avatar-tile__presence rounded-circle"
              [ngClass]="dotFor(person)"
              aria-hidden="true"
            ></span>
          </span>
          <span class="flex-grow-1 chat-name text-start">
            {{ person.name }}
            @if (person.isSelf) {
              <small class="text-muted">{{ 'chat.dialog.yourself' | translate }}</small>
            }
          </span>
          @if (isSelected(person)) {
            <i class="ri-checkbox-circle-fill text-primary flex-shrink-0"></i>
          } @else {
            <i class="ri-checkbox-blank-circle-line text-muted flex-shrink-0"></i>
          }
        </button>
      }
    </div>
  }
</div>

<div class="modal-footer justify-content-between">
  <small class="text-muted">
    @if (selectedCount > 0) {
      {{ 'chat.dialog.selectedCount' | translate:{ count: selectedCount } }}
    }
  </small>
  <div class="d-flex gap-1">
    <button type="button" class="btn btn-light" (click)="close()">{{ 'chat.dialog.cancel' | translate }}</button>
    <button type="button" class="btn btn-primary" [disabled]="selectedCount === 0 || submitting" (click)="confirm()">
      @if (submitting) {
        <span class="spinner-border spinner-border-sm me-1" role="status"></span>
        <span>{{ 'chat.dialog.creating' | translate }}</span>
      } @else {
        <span>{{ 'chat.dialog.start' | translate }}</span>
      }
    </button>
  </div>
</div>
